import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import './UserMenu.css';

const UserMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { user, logout } = useAuth();
  const { theme, setTheme, available } = useTheme();
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = async () => {
    await logout();
    setIsOpen(false);
  };

  if (!user) return null;

  return (
    <div className="user-menu-container" ref={menuRef}>
      <button
        className="user-menu-trigger"
        onClick={() => setIsOpen(!isOpen)}
        title={user.username}
      >
        <div className="user-avatar">
          {user.username.charAt(0).toUpperCase()}
        </div>
      </button>

      {isOpen && (
        <div className="user-menu-dropdown">
          {/* User info */}
          <div className="user-menu-header">
            <div className="user-info">
              <div className="user-info-name">{user.username}</div>
              {user.email && <div className="user-info-email">{user.email}</div>}
              {user.is_staff && <div className="user-info-badge">Admin</div>}
            </div>
          </div>

          <div className="user-menu-divider"></div>

          {/* Appearance. Driven by whatever themes styles/themes.js defines. */}
          <div className="user-menu-section-label">Appearance</div>
          <div className="user-menu-themes">
            {available.map(({ key, label, description }) => (
              <button
                key={key}
                type="button"
                className={`user-menu-theme-option${theme === key ? ' active' : ''}`}
                onClick={() => setTheme(key)}
                aria-pressed={theme === key}
              >
                <span className="theme-option-info">
                  <span className="theme-option-label">{label}</span>
                  <span className="theme-option-desc">{description}</span>
                </span>
                {theme === key && (
                  <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                    <path d="M13.5 4.5L6.5 11.5L3 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                )}
              </button>
            ))}
          </div>

          <div className="user-menu-divider"></div>

          {/* Logout */}
          <button className="user-menu-logout" onClick={handleLogout}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M6 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M10.6667 11.3333L14 8L10.6667 4.66667" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M14 8H6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default UserMenu;

